import moment from 'moment';
import { bool, number, shape, string } from 'prop-types';
import React, { useRef } from 'react';

import CurrencyFormat from '../../generic/CurrencyFormat';
import HoverDetails from '../../generic/HoverDetails';
import IconLink from '../../generic/IconLink';
import { INTERNAL_DATE_FORMAT } from '../../utils/constants';

function CampaignLink({ model, className, showIcon }) {
  const {
    id,
    name,
    nCode,
    status,
    spendableBudget,
    totalSpentBudget,
    startDatePlan,
    endDatePlan,
  } = model;
  const linkRef = useRef(null);
  const getPlannedRuntime = (startDate, endDate) =>
    `${moment(startDate).format(INTERNAL_DATE_FORMAT)} until ${moment(
      endDate,
    ).format(INTERNAL_DATE_FORMAT)}`;
  return (
    <>
      <span ref={linkRef}>
        <IconLink showIcon={showIcon} to={`/campaigns/${id}/edit`}>
          {name}
        </IconLink>
      </span>
      <HoverDetails
        size="large"
        linkRef={linkRef}
        className={className}
        title={name}
        fields={{
          Ncode: nCode,
          'Setup Status': status,
          'Planned Runtime': getPlannedRuntime(startDatePlan, endDatePlan),
          'Spendable Budget': (
            <CurrencyFormat
              name="spendableBudget"
              value={spendableBudget || 0}
              text
            />
          ),
          'Total Spent Budget': (
            <CurrencyFormat
              name="totalSpentBudget"
              value={totalSpentBudget || 0}
              text
            />
          ),
        }}
      />
    </>
  );
}

CampaignLink.propTypes = {
  model: shape({ id: number.isRequired, name: string.isRequired }).isRequired,
  className: string,
  showIcon: bool,
};

CampaignLink.defaultProps = {
  className: '',
  showIcon: false,
};

export default CampaignLink;
